import store from '@/store'
import { extractRoleCode, getHomeRouteByRoleCode, isAdminRole } from '@/config/roles'

export default async (_to, _from, next) => {
  const user = store.getters['auth/user']
  const roleCode = extractRoleCode(user)

  if (!isAdminRole(roleCode)) {
    if (roleCode) {
      next({ name: getHomeRouteByRoleCode(roleCode) })
      return
    }
    next({ name: 'shared.login' })
  } else {
    next()
  }
}
